export const SHOW_WELCOME_DIALOG = 'SHOW_WELCOME_DIALOG';